const BASE_URL_BACKEND_DEV = 'http://127.0.0.1:8000/api/v1';
const BASE_URL_BACKEND_PROD = 'https://back.wesmart.org.il:8000/api/v1';
const BASE_URL_BACKEND_FOR_MEDIA_DEV = 'http://127.0.0.1:8000';
const BASE_URL_BACKEND_FOR_MEDIA_PROD = 'https://back.wesmart.org.il:8000';

export const BASE_URL_BACKEND_FOR_MEDIA = BASE_URL_BACKEND_FOR_MEDIA_PROD;

export const BASE_URL_BACKEND = BASE_URL_BACKEND_PROD;
